import { z } from 'zod';

/**
 * Document node - files and records attached to other entities
 */
export const DocumentPropsSchema = z.object({
  external_id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  type: z.string().min(1, 'Type is required'),
  status: z.string().optional(),
  file_url: z.string().url().optional(),
});

export type DocumentProps = z.infer<typeof DocumentPropsSchema>;
